export default "__VITE_ASSET__Cyei_3df__"